// extracted by mini-css-extract-plugin
module.exports = {"visible":"Slide_visible__Ox_Le","hidden-x":"Slide_hidden-x__Ef_X2","hidden-y":"Slide_hidden-y__euiR9 Slide_hidden-x__Ef_X2"};